"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    elementContains: function() {
        return _reactutilities.elementContains;
    },
    setVirtualParent: function() {
        return _reactutilities.setVirtualParent;
    },
    Portal: function() {
        return _index.Portal;
    },
    renderPortal_unstable: function() {
        return _index.renderPortal_unstable;
    },
    usePortal_unstable: function() {
        return _index.usePortal_unstable;
    },
    toMountNodeProps: function() {
        return _toMountNodeProps.toMountNodeProps;
    }
});
const _reactutilities = require("@fluentui/react-utilities");
const _index = require("./components/Portal/index");
const _toMountNodeProps = require("./utils/toMountNodeProps");
